import React, { useState, useRef } from 'react';
import t from 'prop-types';
import Tirador from './tirador';

function limit(val, min, max) {
  return val < min ? min : val > max ? max : val;
}

function Persiana(_ref) {
  var activa = _ref.activa,
      color = _ref.color,
      posicion = _ref.posicion,
      onPosicion = _ref.onPosicion;

  var _useState = useState(0),
      iLeft = _useState[0],
      setILeft = _useState[1];

  var _useState2 = useState(0),
      iTop = _useState2[0],
      setITop = _useState2[1];

  var _useState3 = useState(0),
      iRight = _useState3[0],
      setIRight = _useState3[1];

  var _useState4 = useState(0),
      iBottom = _useState4[0],
      setIBottom = _useState4[1]; // const [ offset, setOffset ] = useState({ left: 0, top: 0, right: 0, bottom: 0 })


  var persianaRef = useRef(null);

  function handleArrastrandoTiradorDerecha(_ref2) {
    var ix = _ref2.ix,
        iy = _ref2.iy;

    if (!persianaRef.current) {
      return;
    }

    var _persianaRef$current$ = persianaRef.current.parentNode.getBoundingClientRect(),
        width = _persianaRef$current$.width;

    setIRight(-100 * ix / width); // setOffset({
    //     ...offset,
    //     right: -100 * ix / width
    // })
  }

  function handleArrastrandoTiradorIzquierda(_ref3) {
    var ix = _ref3.ix,
        iy = _ref3.iy;

    if (!persianaRef.current) {
      return;
    }

    var _persianaRef$current$2 = persianaRef.current.parentNode.getBoundingClientRect(),
        width = _persianaRef$current$2.width;

    setILeft(100 * ix / width); // setOffset({
    //     ...offset,
    //     left: 100 * ix / width
    // })
  }

  function handleArrastrandoTiradorSuperior(_ref4) {
    var ix = _ref4.ix,
        iy = _ref4.iy;

    if (!persianaRef.current) {
      return;
    }

    var _persianaRef$current$3 = persianaRef.current.parentNode.getBoundingClientRect(),
        height = _persianaRef$current$3.height;

    setITop(100 * iy / height); // setOffset({
    //     ...offset,
    //     top: 100 * iy / height
    // })
  }

  function handleArrastrandoTiradorInferior(_ref5) {
    var ix = _ref5.ix,
        iy = _ref5.iy;

    if (!persianaRef.current) {
      return;
    }

    var _persianaRef$current$4 = persianaRef.current.parentNode.getBoundingClientRect(),
        height = _persianaRef$current$4.height;

    setIBottom(-100 * iy / height); // setOffset({
    //     ...offset,
    //     bottom: -100 * iy / height
    // })
  }

  function handleTiradorTerminarArrastre() {
    onPosicion && onPosicion({
      left: posicion.left + iLeft,
      top: posicion.top + iTop,
      right: posicion.right + iRight,
      bottom: posicion.bottom + iBottom
    });
    setILeft(0);
    setITop(0);
    setIRight(0);
    setIBottom(0); // setOffset({ left: 0, top: 0, right: 0, bottom: 0 })
  }

  if (!activa) {
    return null;
  }

  var style = {
    position: 'absolute',
    left: limit(posicion.left + iLeft, 0, 100) + '%',
    top: limit(posicion.top + iTop, 0, 100) + '%',
    right: limit(posicion.right + iRight, 0, 100) + '%',
    bottom: limit(posicion.bottom + iBottom, 0, 100) + '%',
    backgroundColor: color || "black",
    boxSizing: 'border-box'
  };
  return React.createElement('div', {
    ref: persianaRef,
    className: 'persiana abierta',
    style: style
  }, React.createElement(Tirador, {
    clase: 'tiradorIzquierda',
    onArrastrando: handleArrastrandoTiradorIzquierda,
    onTerminar: handleTiradorTerminarArrastre
  }), React.createElement(Tirador, {
    clase: 'tiradorDerecha',
    onArrastrando: handleArrastrandoTiradorDerecha,
    onTerminar: handleTiradorTerminarArrastre
  }), React.createElement(Tirador, {
    clase: 'tiradorArriba',
    onArrastrando: handleArrastrandoTiradorSuperior,
    onTerminar: handleTiradorTerminarArrastre
  }), React.createElement(Tirador, {
    clase: 'tiradorAbajo',
    onArrastrando: handleArrastrandoTiradorInferior,
    onTerminar: handleTiradorTerminarArrastre
  }));
}

Persiana.propTypes = process.env.NODE_ENV !== "production" ? {
  activa: t.bool.isRequired,
  posicion: t.shape({
    left: t.number.isRequired,
    top: t.number.isRequired,
    right: t.number.isRequired,
    bottom: t.number.isRequired
  }).isRequired,
  color: t.string,
  onPosicion: t.func.isRequired
} : {};
export default Persiana;